module.exports = __webpack_public_path__ + "img/PSSS-M-18.65df00dd.svg";